<template>
  <div class="wrapper">
    <div class="animated fadeIn ">
      <div>
       <b-row>
        <b-col cols="12">
         <b-breadcrumb :items="breadcrumbs"/>
         <!-- Code added -->
          <b-card header-tag="header" footer-tag="footer" style=" margin-bottom: 0px;">
             <!-- <b-row class="col-md-12 lgtypelist mt-3">
                 
            <div class="col mx-1">
              <label>Gender</label>
                <b-form-group>
                  <b-form-select @change="showCollection(brand_id, selected_segment_id)"
                    v-model="selected_segment_id"
                    id="selected_segment_id"
                    name="selected_segment_id"
                    placement="Select Gender"
                  >
                    <option :value="null">--Select Gender--</option>
                    <option v-for="segmentlist in segmentarray_list" :value="segmentlist.segment_id" :key="segmentlist.segment_id">{{
                      segmentlist.segment_title
                    }}</option>
                  </b-form-select>
                </b-form-group>
            </div> 
            <div class="col mx-1">
              <label>Season</label>
               <b-form-group >
                  <b-form-select @change="showSubcategory(selected_collection_id)"
                    v-model="selected_collection_id"
                    id="selected_collection_id"
                    name="selected_collection_id"
                  >
                    <option :value="null">--Select Season--</option>
                    <option v-for="collection in collectionData" :value="collection.collection_id" :key="collection.collection_id">{{
                      collection.collection_title
                    }}</option>
                  </b-form-select>
                </b-form-group>
            </div> 
            <div class="col mx-1">

              <label>Sub-category</label>
                 <b-form-group >
                  <b-form-select @change="getPoTypeList(sub_catid);"
                    v-model="sub_catid"
                    id="sub_catid"
                    name="sub_catid"
                  >
                    <option :value="null">--Select Sub-category--</option>
                    <option v-for="subcatarry in sub_cat_id_arr" :value="subcatarry.sub_catid" :key="subcatarry.sub_catid">{{
                      subcatarry.sub_cattitle
                    }}</option>
                  </b-form-select>
                </b-form-group>
            </div>
             <div class="col mx-1">
              <label>PO Type (PT)</label>
                <b-form-group >
                
                  <b-form-select
                    v-model="selected_po_id"
                    id="selected_po_id"
                    name="selected_po_id"
                  >
                    <option :value="null">--Select PO Type--</option>
                    <option v-for="polist in po_typearr" :value="polist.po_id" :key="polist.po_id">{{
                      polist.potype_title
                    }}</option>
                  </b-form-select>
                </b-form-group>
            </div> 
            <div class="col mx-1">
              <label></label>
              <b-form-group>
               <b-button @click="searchData(brand_id)"
                      type="submit"
                      variant="primary"
                      class="px-4 pull-left mt-2"
                      >Search</b-button
                    >
                  <button
                    class="btn btn-sm btn-primary ml-3 mt-2 px-3 pb-2"
                    v-on:click="refresh()"
                    type="button"
                  >
                    <i class="fa fa-refresh"></i>
                  </button>
                </b-form-group>
            </div> 
 
          </b-row>  -->

          <b-row class="col-md-12 lgtypelist mt-3">
                 
                 <div class="col mx-1">
     
                   <b-input-group class="mt-2">
                                 
                     <ejs-multiselect
                       id="selected_segment_id"
                       placeholder="Select Segment"
                       v-model="selected_segment_id"
                       name="selected_segment_id"
                       :fields="segementid_fields"
                       :dataSource="segmentarray_list"
                       :showSelectAll="true"
                       :class="{ input: true }"
                     >
                     </ejs-multiselect>
                   </b-input-group>
     
                   <!-- <label>Gender</label>
                     <b-form-group>
                       <b-form-select @change="showCollection(brand_id, selected_segment_id)"
                         v-model="selected_segment_id"
                         id="selected_segment_id"
                         name="selected_segment_id"
                         placement="Select Gender"
                       >
                         <option :value="null">--Select Gender--</option>
                         <option v-for="segmentlist in segmentarray_list" :value="segmentlist.segment_id" :key="segmentlist.segment_id">{{
                           segmentlist.seg_name
                         }}</option>
                       </b-form-select>
                     </b-form-group> -->
                 </div> 
                 <div class="col mx-1">
                   <b-input-group class="mt-2">
                                 
                     <ejs-multiselect
                       id="selected_collection_id"
                       placeholder="Select Season"
                       v-model="selected_collection_id"
                       name="selected_collection_id"
                       :fields="collectionid_fields"
                       :dataSource="collectionData"
                       :showSelectAll="true"
                       :class="{ input: true }"
                     >
                     </ejs-multiselect>
                   </b-input-group>
                   <!-- <label>Season</label>
                    <b-form-group >
                       <b-form-select @change="showSubcategory(selected_collection_id)"
                         v-model="selected_collection_id"
                         id="selected_collection_id"
                         name="selected_collection_id"
                       >
                         <option :value="null">--Select Season--</option>
                         <option v-for="collection in collectionData" :value="collection.collection_id" :key="collection.collection_id">{{
                           collection.collection_title
                         }}</option>
                       </b-form-select>
                     </b-form-group> -->
                 </div> 
                 <div class="col mx-1">
     
                   <b-input-group class="mt-2">
                                 
                     <ejs-multiselect
                       id="sub_catid"
                       placeholder="Select Sub-Category"
                       v-model="sub_catid"
                       name="sub_catid"
                       :fields="subcatid_fields"
                       :dataSource="sub_cat_id_arr"
                       :showSelectAll="true"
                       :class="{ input: true }"
                     >
                     </ejs-multiselect>
                   </b-input-group>
     
                   <!-- <label>Sub-category</label>
                      <b-form-group >
                       <b-form-select @change="getPoTypeList(sub_catid);"
                         v-model="sub_catid"
                         id="sub_catid"
                         name="sub_catid"
                       >
                         <option :value="null">--Select Sub-category--</option>
                         <option v-for="subcatarry in sub_cat_id_arr" :value="subcatarry.sub_catid" :key="subcatarry.sub_catid">{{
                           subcatarry.sub_cattitle
                         }}</option>
                       </b-form-select>
                     </b-form-group> -->
                 </div>
                  <div class="col mx-1">
                   <b-input-group class="mt-2">
                                 
                     <ejs-multiselect
                       id="selected_po_id"
                       placeholder="Select PO Id"
                       v-model="selected_po_id"
                       name="selected_po_id"
                       :fields="poid_fields"
                       :dataSource="po_typearr"
                       :showSelectAll="true"
                       :class="{ input: true }"
                     >
                     </ejs-multiselect>
                   </b-input-group>
                   <!-- <label>PO Type (PT)</label>
                     <b-form-group >
                     
                       <b-form-select
                         v-model="selected_po_id"
                         id="selected_po_id"
                         name="selected_po_id"
                       >
                         <option :value="null">--Select PO Type--</option>
                         <option v-for="polist in po_typearr" :value="polist.po_id" :key="polist.po_id">{{
                           polist.potype_title
                         }}</option>
                       </b-form-select>
                     </b-form-group> -->
                 </div> 
                 <div class="col mx-1">
                   <label></label>
                   <b-form-group>
                    <b-button @click="searchData(brand_id)"
                           type="submit"
                           variant="primary"
                           class="px-4 pull-left"
                           >Search</b-button
                         >
                       <button
                         class="btn btn-sm btn-primary ml-3 px-3 pb-2"
                         v-on:click="refresh()"
                         type="button"
                       >
                         <i class="fa fa-refresh"></i>
                       </button>
                     </b-form-group>
                 </div> 
      
               </b-row>

          <hr>
            <label style="margin-left: 20px;" class="mt-3">All Designs : </label>         
            <b-row class="boxto">     
       

                <b-col sm="6" lg="2" >
                <b-card no-body class="bg-aqua" >
                 <router-link  :to="'/style_list/' +'ALL_Designs'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Designs rejecte">{{ALL_Designs}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="My Designs"> All Designs</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>
            </b-row>
            <hr style="height:30px">
            <label style="margin-left: 20px;">Design Styles : </label> 
            <b-row class="boxto">    
              <b-col sm="6" lg="2" >

                <b-card no-body class="bg-aqua"  >
                    <router-link :to="'/style_list/' + 'Designs_Pending_For_Approval'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="Designs pending for approval">{{Designs_Pending_For_Approval}} </h4>
                     <p class="text-center countcolor"  v-b-tooltip.hover title="Designs pending for approval">Designs pending for approval</p>
                  </b-card-body>
                   </router-link>   
                </b-card>
              </b-col>
              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-purpal"  >
                <router-link  :to="'/style_list/' +'Designs_Approved'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Designs approve)">{{Designs_Approved}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Designs approved"> Designs approved</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>


              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-def" >
                <router-link  :to="'/style_list/' +'Designs_Rejected'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Designs rejecte">{{Designs_Rejected}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title=" Designs rejected)"> Designs rejected</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>

              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-green" >
                <router-link  :to="'/style_list/' +'Designs_Feedback'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Designs rejecte">{{Designs_Feedback}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title=" Designs rejected)"> Designs Feedback</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>

              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-pink" >
                  <router-link  :to="'/style_list/' +'Designs_Draft'">
                  <b-card-body class="pb-0">
                            
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title=" Designs Draft">{{Designs_Draft}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Designs Draft">Designs Draft</p>
                  </b-card-body>
                   </router-link>            
                </b-card>
              </b-col>
            
            </b-row>
            <hr style="height:30px">



            <label style="margin-left: 20px;">Files : </label>         
            <b-row class="boxto">     
              <b-col sm="6" lg="2" >

                <b-card no-body class="bg-aqua"  >
                    <router-link :to="'/style_list/' + 'Tech_Pack_Uploaded'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="Designs pending for approval">{{Tech_Pack_Uploaded}} </h4>
                     <p class="text-center countcolor"  v-b-tooltip.hover title="Designs pending for approval">Tech Pack Uploaded</p>
                  </b-card-body>
                   </router-link>   


                </b-card>
              </b-col>
              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-purpal"  >
                <router-link  :to="'/style_list/' +'BOM_Uploaded'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Designs approve)">{{BOM_Uploaded}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Designs approved"> BOM Uploaded</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>


              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-def" >
                <router-link  :to="'/style_list/' +'Measurment_Chart_Uploaded'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Designs rejecte">{{Measurment_Chart_Uploaded}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title=" Designs rejected)"> Measurement Chart Uploaded</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>

              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-green"  >
                <router-link  :to="'/style_list/' +'All_Files_Uploaded'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="All Files Uploaded)">{{All_Files_Uploaded}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Designs approved"> All Files Uploaded</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>
            
            </b-row>
            <hr style="height:30px">


  
           <!-- <label style="margin-left: 20px;">Quotations:</label>         
            <b-row class="boxto">  

              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-aqua" >
                <router-link  :to="'/style_list/' +'Quotation_pending'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="In quotation">{{Quotation_pending}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="In quotation">Quotation pending</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>

       
               <b-col sm="6" lg="2" >
                <b-card no-body class="bg-purpal"  >
                <router-link  :to="'/style_list/' +'In_Quotation'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Quotation pending)">{{In_Quotation}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Quotation pending">In quotation</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>
               

           

              <b-col sm="6" lg="2" class="pointer">
                <b-card no-body class="bg-def" >
                  <router-link  :to="'/style_list/' +'Quotation_received'">
                      <b-card-body class="pb-0">  
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="Quotation received">{{Quotation_received}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor " v-b-tooltip.hover title="Quotation received">Quotation received</p>
                  </b-card-body>   
                  </router-link>     
                </b-card>
              </b-col>

               <b-col sm="6" lg="2" >
                <b-card no-body class="bg-green" >
                  <router-link  :to="'/style_list/' +'Quotation_approved'">
                  <b-card-body class="pb-0">
                            
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title=" Quotation approved">{{Quotation_approved}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Quotation approved">Quotation approved</p>
                  </b-card-body>
                   </router-link>            
                </b-card>
              </b-col>   

              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-pink" >
                  <router-link  :to="'/style_list/' +'Quotation_rejected'">
                  <b-card-body class="pb-0">
                            
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title=" Quotation Rejected">{{Quotation_rejected}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Quotation Rejected">Quotation Rejected</p>
                  </b-card-body>
                   </router-link>            
                </b-card>
              </b-col>
             
            </b-row>
             <hr style="height:30px"> -->


              <!-- <label style="padding-top: 10px!important; margin-left: 20px;">Sampling :</label>                
              <b-row class="boxto"> 
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-aqua" >
                    <router-link  :to="'/style_list/' +'proto_sampling_pending'">
                    <b-card-body class="pb-0">          
                      <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Proto Sampling pendin)" >{{proto_sampling_pending}}</h4>
                      <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Proto Sampling pending">Proto Sampling pending</p>
                    </b-card-body> 
                    </router-link>       
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-purpal" >
                    <router-link  :to="'/style_list/' +'proto_sampling_rejected'">
                    <b-card-body class="pb-0">          
                      <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Proto Sampling requested" >{{proto_sampling_rejected}}</h4>
                      <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Proto Sampling requested">Proto Sampling Rejected</p>
                    </b-card-body> 
                    </router-link>       
                  </b-card>
                </b-col>
                
                
              
                
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-def" >
                    <router-link  :to="'/style_list/' +'proto_sampling_approved'">
                    <b-card-body class="pb-0">          
                      <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Proto Sampling approved" >{{proto_sampling_approved}}</h4>
                      <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Proto Sampling approved">Proto Sampling approved</p>
                    </b-card-body> 
                    </router-link>       
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-green" >
                    <router-link  :to="'/style_list/' +'pp_pending'">
                    <b-card-body class="pb-0">          
                      <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="PP pending" >{{pp_pending}}</h4>
                      <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="PP pending">PP pending</p>
                    </b-card-body> 
                    </router-link>       
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-pink" >
                    <router-link  :to="'/style_list/' +'pp_sampling_requested'">
                    <b-card-body class="pb-0">          
                      <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="PP requested" >{{pp_sampling_requested}}</h4>
                      <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="PP requested">PP requested</p>
                    </b-card-body> 
                    </router-link>       
                  </b-card>
                </b-col>
                
              
                
            
                
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-red">
                    <router-link  :to="'/style_list/' +'pp_approved'">
                    <b-card-body class="pb-0">          
                      <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="PP approved">{{pp_approved}}</h4>
                      <p  style="padding-bottom: 20px;" class="text-center countcolor"  v-b-tooltip.hover title="PP approve">PP approved</p>
                    </b-card-body>
                      </router-link>        
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" >
                  <b-card no-body class="bg-aqua">
                    <router-link  :to="'/style_list/' +'po_created'">
                    <b-card-body class="pb-0">          
                      <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="PO Created">
                      {{po_created}}</h4>
                      <p style="padding-bottom: 20px;" class="text-center countcolor"  v-b-tooltip.hover title="PP Rejected"> PO Created</p>
                    </b-card-body> 
                  </router-link>       
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" >
                  <b-card no-body class="bg-purpal">
                    <router-link  :to="'/style_list/' +'proto_dispatched'">
                    <b-card-body class="pb-0">          
                      <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="Proto Dispatched">
                      {{proto_dispatched}}</h4>
                      <p style="padding-bottom: 20px;" class="text-center countcolor"  v-b-tooltip.hover title="Proto Dispatched"> Proto Dispatched</p>
                    </b-card-body> 
                  </router-link>       
                  </b-card>
                </b-col> 

                <b-col sm="6" lg="2" >
                  <b-card no-body class="bg-def">
                    <router-link  :to="'/style_list/' +'pp_dispatched'">
                    <b-card-body class="pb-0">          
                      <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="PP Dispatched">
                      {{pp_dispatched}}</h4>
                      <p style="padding-bottom: 20px;" class="text-center countcolor"  v-b-tooltip.hover title="PP Dispatched"> PP Dispatched</p>
                    </b-card-body> 
                  </router-link>       
                  </b-card>
                </b-col>
                
              
              </b-row>  -->
            </b-card> 
             </b-col>
          </b-row>
    </div>






  <!-- <div> -->
      <!-- <b-row>
        <b-col cols="12"> -->
        <!--  <b-breadcrumb :items="breadcrumbs"/> -->
         <!-- Code added -->
          <!-- <b-card > -->
           <!-- Code added by Sachin
            Date:12/02/2020 -->
<!-- 
            <label style="padding-top: 10px!important; margin-left: 20px;">PO</label>
             <b-row class="boxto">     
  
              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-aqua" >
                  <router-link  :to="'/style_list/' +'TNA_uploaded'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="TNA pending)" > {{tna_uploaded}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="TNA pending">TNA Uploaded</p>
                  </b-card-body> 
                   </router-link>        
                </b-card>
              </b-col>
               <b-col sm="6" lg="2" >
                <b-card no-body class="bg-purpal">
                  <router-link  :to="'/style_list/' +'TNA_submitted'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="TNA submitted"> {{TNA_submitted}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor " v-b-tooltip.hover title="TNA submitted">TNA submitted</p>
                  </b-card-body>
                   </router-link>               
                </b-card>
              </b-col>   
              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-def">
                    <router-link  :to="'/style_list/' +'TNA_approved'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="TNA approved"> {{tna_approved}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title=" TNA approved"> TNA Approved</p>
                  </b-card-body>
                  </router-link>       
                </b-card>
              </b-col>  
              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-green">
                   <router-link  :to="'/style_list/' +'In_Preparation'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="In Preparation"> {{In_Preparation}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="In Preparation">In Preparation</p>
                  </b-card-body>  
                  </router-link>       
                </b-card>
              </b-col> 


              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-pink">
                   <router-link  :to="'/style_list/' +'In_Production'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="In production"> {{In_Production}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="In production">In Production</p>
                  </b-card-body>  
                  </router-link>       
                </b-card>
              </b-col>

              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-red">
                   <router-link  :to="'/style_list/' +'Ready_for_Dispatch'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="Ready For Dispatched"> {{Ready_for_Dispatch}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Ready For Dispatched">Ready For Dispatched</p>
                  </b-card-body>  
                  </router-link>       
                </b-card>
              </b-col>  
             
            </b-row> -->
            <!-- Code End -->
            <!-- <strong class="heading">Orders</strong>  -->        

            <!-- <hr style="height:30px"> -->

          <!-- <label style="padding-top: 10px!important">PO</label>
          <b-row class="boxto">     
            <b-col sm="6" lg="2" >
              <b-card no-body class="bg-aqua">
                <router-link  :to="'/style_list/' +'PO_Created'">
                <b-card-body class="pb-0">          
                  <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="PO Created">
                  {{PO_Created}}</h4>
                  <p style="padding-bottom: 20px;" class="text-center countcolor"  v-b-tooltip.hover title="PO Created"> PO Created</p>
                </b-card-body> 
              </router-link>       
              </b-card>
            </b-col>

            <b-col sm="6" lg="2" >
              <b-card no-body class="bg-def">
                <router-link  :to="'/style_list/' +'PO_Updated'">
                <b-card-body class="pb-0">          
                  <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="PO Updated">
                  {{PO_Updated}}</h4>
                  <p style="padding-bottom: 20px;" class="text-center countcolor"  v-b-tooltip.hover title="PO Updated"> PO Updated</p>
                </b-card-body> 
              </router-link>       
              </b-card>
            </b-col>
            
            <b-col sm="6" lg="2" >
              <b-card no-body class="bg-purpal">
                <router-link  :to="'/style_list/' +'PO_submitted'">
                <b-card-body class="pb-0">          
                  <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="PO submitted"> {{PO_submitted}}</h4>
                  <p style="padding-bottom: 20px;" class="text-center countcolor"  v-b-tooltip.hover title="PO submittedd">PO submitted</p>
                </b-card-body> 
                </router-link>              
              </b-card>
            </b-col>

          </b-row> -->

        <!-- <hr style="height:30px"> -->

          <!-- <label style="padding-top: 10px!important; margin-left: 20px;">Orders</label> -->
             <!-- <b-row class="boxto" >      -->
              <!-- <b-col sm="6" lg="2" class="pointer">
                <b-card no-body class="bg-aqua">
                   <router-link  :to="'/style_list/' +'Designs_Rejected'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="Order pendin">
                    {{Order_pending}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor"  v-b-tooltip.hover title="Order pending">Order pending</p>
                  </b-card-body> 
                   </router-link>         
                </b-card>
              </b-col> -->
              
              <!-- <b-col sm="6" lg="2" class="pointer">
                <b-card no-body class="bg-purpal">
                 <router-link  :to="'/style_list/' +'Designs_Rejected'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="Order submitted"> {{Order_submitted}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor"  v-b-tooltip.hover title="Order submitted">Order submitted</p>
                  </b-card-body>
                  </b-card-body> 
                   </router-link>             
                </b-card>
              </b-col> -->
              <!-- <b-col sm="6" lg="2" class="pointer">
                <b-card no-body class="bg-def" >
                  <router-link  :to="'/style_list/' +'Designs_Rejected'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Order received" > {{Order_received}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Order received">Order received</p>
                  </b-card-body> 
                   </router-link>       
                </b-card>
              </b-col> -->
               
        
             
<!--                
            </b-row>
                   





            
          </b-card>
        </b-col>
      </b-row> -->
    <!-- </div> -->




  </div>
</div>
 
           
          
</template>


<script>

import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import auth from "@/utils/auth";
 import Router from 'vue-router'
const axios = require('axios');
export default {
  name: 'dashboard',
  data: function () {
    return {
      name: 'dashboard',
      id: '',
      Firstmile:[],
      Lasttmile:[],
      Reverse:[],
     a:-1,
    pending_for_approval: 0,
    ALL_Designs: 0,
    Designapproved:0,
    designrejected: 0,

      inprogress: 0,
      approved: 0,
      pending: 0,
      received: 0,

    BOM_Uploaded: 0,
    Measurment_Chart_Uploaded: 0,
    Tech_Pack_Uploaded: 0,
    All_Files_Uploaded: 0,

      In_Quotation: 0,
     Order_pending: 0,
     Order_received: 0,
     Order_submitted: 0,
     PO_Updated: 0,
      PO_Created: 0,
      PO_submitted:0,
    tna_approved: 0,
    TNA_pending: 0,
    TNA_submitted: 0,


    proto_sampling_pending: 0,
    proto_sampling_rejected:0,
    proto_sampling_approved:0,
    pp_pending:0,
    pp_sampling_requested:0,
    pp_approved:0,
    pp_rejected:0,
    proto_dispatched: 0,
    pp_dispatched: 0,


    rejected: 0,
    resultData:[],
    Designs_Approved : 0,
    Designs_Rejected : 0,
    Designs_Feedback: 0,
    Designs_Draft: 0,
    Designs_Pending_For_Approval : 0,
    Quotation_pending :0,
    Quotation_received:0,
    Quotation_approved:0,
    Quotation_rejected:0,

    PO_CreatedPO_submitted : 0,
    TNA_pending : 0,
    tna_uploaded : 0,
    tna_approved : 0,
    In_Preparation : 0,
    In_Production : 0,
    Ready_for_Dispatch : 0,
    Order_pending : 0,
    Order_submitted : 0,
    Order_received : 0,
    po_created: 0,
       breadcrumbs: [{
        text: 'Dashboard',
        active: true
      }],
      // Search Data
      segmentarray_list: [],
      selected_segment_id: null,
      collectionData: [],
      collection_brand_id: "",
      collection_segment_id: "",
      selected_collection_id: null,
      brand_id: '',
      segment_id: '',
      segmentList_arr: [],
      totalRows: 0,
      sub_catid: "",
      sub_cat_id_arr: [],
      po_typearr: [],
      sub_catid: null,
      selected_po_id: null,
      result: [],
      segementid_fields: { text: "text", value: "value" },
      collectionid_fields:  { text: "text", value: "value" },
      subcatid_fields: { text: "text", value: "value" },
      poid_fields:  { text: "text", value: "value" },
    }
  },
 
  created: function () {
    var userData = localStorage.getItem('userData');
    var userInfo = JSON.parse(userData)
    localStorage.setItem('formData', JSON.stringify({}));

    this.brand_id = userInfo[0].brand_assign;
    this.showCollection(this.brand_id);
    this.showSubcategory(this.selected_collection_id);
    this.getPoTypeList(this.sub_catid);
  },
  mounted() {
    var userData = localStorage.getItem('userData');
    var userInfo = JSON.parse(userData)
    let tempLocalStorage = localStorage.filters ? JSON.parse(localStorage.filters) : null
    console.log('tempLocalStorage-------->',tempLocalStorage)
    if(tempLocalStorage){
      if(tempLocalStorage.selected_segment_id){
        this.selected_segment_id = tempLocalStorage.selected_segment_id
        this.showCollection(userInfo[0].brand_assign,tempLocalStorage.selected_segment_id)
        this.selected_collection_id = tempLocalStorage.selected_collection_id
        if(tempLocalStorage.selected_collection_id){
          this.showSubcategory(tempLocalStorage.selected_collection_id)
        }
        this.sub_catid = tempLocalStorage.sub_catid
        if(tempLocalStorage.sub_catid){
          this.getPoTypeList(tempLocalStorage.sub_catid)
        }
        this.selected_po_id = tempLocalStorage.selected_po_id
      }
      
    }
    this.displayDashboardData();
    this.getBrandSegmentList();
  },
  methods: {
    
      displayDashboardData: function () {
         var userData = localStorage.getItem('userData');
          var userInfo = JSON.parse(userData)
        this.access_token=userInfo[0]['token']
        axios.defaults.headers.common['x-access-token'] = this.access_token;
        axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
        axios.defaults.headers.common['Accept']= 'application/json';
        axios.defaults.headers.common['Origin']='http://localhost:8080';
         
        const Obj = {
           user_id:userInfo[0].user_id,
           user_type:userInfo[0].user_type,
          brand_id: userInfo[0].brand_assign,
          segment_id: this.selected_segment_id ? this.selected_segment_id : null,
          collection_id: this.selected_collection_id ? this.selected_collection_id : null,
          sub_catid: this.sub_catid ? this.sub_catid : null,
          po_id: this.selected_po_id ? this.selected_po_id : null
                   
                 
                  }
        
      axios.post(`${CONSTANTS.API_URL}/getdashboardcountfordesigner`,Obj)
                .then(response => {
                 var result = response.data
                 this.resultData = response.data.returnvalue[0];
                  if (result.returnmsg === 'Successful') {
                    if(this.resultData.All_Designs.ALL_Designs== '0'){
                      this.$fire({
                          text: "No records found",
                          type: "warning",
                          timer: 30000,
                        });
                    }
                   
       
        // this.Designs_Approved = this.resultData.Design_Styles.Designs_Approved 
        // this.Designs_Rejected = this.resultData.Design_Styles.Designs_Rejected
        // this.Designs_Pending_For_Approval= this.resultData.Design_Styles.Designs_Pending_For_Approval
        if(this.resultData.Design_Styles.Designs_Pending_For_Approval=='' || this.resultData.Design_Styles.Designs_Pending_For_Approval==null || this.resultData.Design_Styles.Designs_Pending_For_Approval==undefined){
                      this.Designs_Pending_For_Approval= 0;
                    }
                    else{
                      this.Designs_Pending_For_Approval= this.resultData.Design_Styles.Designs_Pending_For_Approval
                    }
                    if(this.resultData.All_Designs.ALL_Designs=='' || this.resultData.All_Designs.ALL_Designs==null || this.resultData.All_Designs.ALL_Designs==undefined){
                      this.ALL_Designs= 0;
                    }
                    else{
                      this.ALL_Designs= this.resultData.All_Designs.ALL_Designs
                    }

                   if(this.resultData.Design_Styles.Designs_Approved=='' || this.resultData.Design_Styles.Designs_Approved==null || this.resultData.Design_Styles.Designs_Approved==undefined){
                      this.Designs_Approved= 0;
                    }
                    else{
                      this.Designs_Approved= this.resultData.Design_Styles.Designs_Approved
                    }

                  if(this.resultData.Design_Styles.Designs_Rejected=='' || this.resultData.Design_Styles.Designs_Rejected==null || this.resultData.Design_Styles.Designs_Rejected==undefined){
                      this.Designs_Rejected= 0;
                    }
                  else{
                    this.Designs_Rejected= this.resultData.Design_Styles.Designs_Rejected;
                  }

                  if(this.resultData.Design_Styles.Designs_Feedback=='' || this.resultData.Design_Styles.Designs_Feedback==null || this.resultData.Design_Styles.Designs_Feedback==undefined){
                      this.Designs_Feedback= 0;
                    }
                  else{
                    this.Designs_Feedback= this.resultData.Design_Styles.Designs_Feedback;
                  }

                  if(this.resultData.Design_Styles.Designs_Draft=='' || this.resultData.Design_Styles.Designs_Draft==null || this.resultData.Design_Styles.Designs_Draft==undefined){
                      this.Designs_Draft= 0;
                    }
                  else{
                    this.Designs_Draft= this.resultData.Design_Styles.Designs_Draft;
                  }


                  if(this.resultData.Files.BOM_Uploaded=='' || this.resultData.Files.BOM_Uploaded==null || this.resultData.Files.BOM_Uploaded==undefined){
                      this.BOM_Uploaded= 0;
                    }
                    else{
                      this.BOM_Uploaded= this.resultData.Files.BOM_Uploaded
                    }

                    if(this.resultData.Files.Measurment_Chart_Uploaded=='' || this.resultData.Files.Measurment_Chart_Uploaded==null || this.resultData.Files.Measurment_Chart_Uploaded==undefined){
                                  this.Measurment_Chart_Uploaded= 0;
                    }
                    else{
                      this.Measurment_Chart_Uploaded= this.resultData.Files.Measurment_Chart_Uploaded
                    }

                    if(this.resultData.Files.Tech_Pack_Uploaded=='' || this.resultData.Files.Tech_Pack_Uploaded==null || this.resultData.Files.Tech_Pack_Uploaded==undefined){
                                  this.Tech_Pack_Uploaded= 0;
                    }
                    else{
                      this.Tech_Pack_Uploaded= this.resultData.Files.Tech_Pack_Uploaded
                    }

                    if(this.resultData.Files.All_Files_Uploaded=='' || this.resultData.Files.All_Files_Uploaded==null || this.resultData.Files.All_Files_Uploaded==undefined){
                           this.All_Files_Uploaded= 0;
                    }
                    else{
                      this.All_Files_Uploaded= this.resultData.Files.All_Files_Uploaded
                    }


                  

                    if(this.resultData.Quotations.In_Quotation=='' || this.resultData.Quotations.In_Quotation==null || this.resultData.Quotations.In_Quotation==undefined){
                      this.In_Quotation= 0;
                    }
                    else{
                      this.In_Quotation= this.resultData.Quotations.In_Quotation
                    }

                    if(this.resultData.Quotations.Quotation_pending=='' || this.resultData.Quotations.Quotation_pending==null || this.resultData.Quotations.Quotation_pending==undefined){
                                  this.Quotation_pending= 0;
                    }
                    else{
                      this.Quotation_pending= this.resultData.Quotations.Quotation_pending
                    }
                    if(this.resultData.Quotations.Quotation_received=='' || this.resultData.Quotations.Quotation_received==null || this.resultData.Quotations.Quotation_received==undefined){
                                  this.Quotation_received= 0;
                    }
                    else{
                      this.Quotation_received= this.resultData.Quotations.Quotation_received
                    }
                   
                    if(this.resultData.Quotations.Quotation_approved=='' || this.resultData.Quotations.Quotation_approved==null || this.resultData.Quotations.Quotation_approved==undefined){
                                  this.Quotation_approved= 0;
                    }
                    else{
                      this.Quotation_approved= this.resultData.Quotations.Quotation_approved
                    }
                    if(this.resultData.Quotations.Quotation_rejected=='' || this.resultData.Quotations.Quotation_rejected==null || this.resultData.Quotations.Quotation_rejected==undefined){
                                  this.Quotation_rejected= 0;
                    }
                    else{
                      this.Quotation_rejected =this.resultData.Quotations.Quotation_rejected     
                       }

                if(this.resultData.Sampling.proto_sampling_pending=='' || this.resultData.Sampling.proto_sampling_pending==null || this.resultData.Sampling.proto_sampling_pending==undefined){
          this.proto_sampling_pending= 0;
          }
        else{
          this.proto_sampling_pending= this.resultData.Sampling.proto_sampling_pending;
        }

        if(this.resultData.Sampling.proto_sampling_rejected=='' || this.resultData.Sampling.proto_sampling_rejected==null || this.resultData.Sampling.proto_sampling_rejected==undefined){
          this.proto_sampling_rejected= 0;
          }
        else{
          this.proto_sampling_rejected= this.resultData.Sampling.proto_sampling_rejected;
        }

        if(this.resultData.Sampling.proto_sampling_approved=='' || this.resultData.Sampling.proto_sampling_approved==null || this.resultData.Sampling.proto_sampling_approved==undefined){
          this.proto_sampling_approved= 0;
          }
        else{
          this.proto_sampling_approved= this.resultData.Sampling.proto_sampling_approved;
        }

        if(this.resultData.Sampling.pp_pending=='' || this.resultData.Sampling.pp_pending==null || this.resultData.Sampling.pp_pending==undefined){
          this.pp_pending= 0;
          }
        else{
          this.pp_pending= this.resultData.Sampling.pp_pending;
        }

        if(this.resultData.Sampling.pp_sampling_requested=='' || this.resultData.Sampling.pp_sampling_requested==null || this.resultData.Sampling.pp_sampling_requested==undefined){
          this.pp_sampling_requested= 0;
          }
        else{
          this.pp_sampling_requested= this.resultData.Sampling.pp_sampling_requested;
        }

        if(this.resultData.Sampling.pp_approved=='' || this.resultData.Sampling.pp_approved==null || this.resultData.Sampling.pp_approved==undefined){
          this.pp_approved= 0;
          }
        else{
          this.pp_approved= this.resultData.Sampling.pp_approved;
        }
        
        if(this.resultData.Sampling.pp_rejected=='' || this.resultData.Sampling.pp_rejected==null || this.resultData.Sampling.pp_rejected==undefined){
          this.pp_rejected= 0;
          }
        else{
          this.pp_rejected= this.resultData.Sampling.pp_rejected;
        }

        if(this.resultData.Sampling.proto_dispatched=='' || this.resultData.Sampling.proto_dispatched==null || this.resultData.Sampling.proto_dispatched==undefined){
          this.proto_dispatched= 0;
          }
        else{
          this.proto_dispatched= this.resultData.Sampling.proto_dispatched;
        }

        if(this.resultData.Sampling.pp_dispatched=='' || this.resultData.Sampling.pp_dispatched==null || this.resultData.Sampling.pp_dispatched==undefined){
          this.pp_dispatched= 0;
          }
        else{
          this.pp_dispatched= this.resultData.Sampling.pp_dispatched;
        }
        
        if(this.resultData.PO.PO_Updated=='' || this.resultData.PO.PO_Updated==null || this.resultData.PO.PO_Updated==undefined){
          this.PO_Updated= 0; 
          }
        else{
          this.PO_Updated= this.resultData.PO.PO_Updated;
        }

        if(this.resultData.PO.PO_Created=='' || this.resultData.PO.PO_Created==null || this.resultData.PO.PO_Created==undefined){
          this.PO_Created= 0;
          }
        else{
          this.PO_Created= this.resultData.PO.PO_Created;
        }

        if(this.resultData.PO.PO_submitted=='' || this.resultData.PO.PO_submitted==null || this.resultData.PO.PO_submitted==undefined){
          this.PO_submitted= 0;PO_submitted
          }
        else{
          this.PO_submitted= this.resultData.PO.PO_submitted;
        }
        if(this.resultData.Tna.tna_uploaded=='' || this.resultData.Tna.tna_uploaded==null || this.resultData.Tna.tna_uploaded==undefined){
          this.tna_uploaded= 0;
          }
        else{
          this.tna_uploaded= this.resultData.Tna.tna_uploaded;
        }

        if(this.resultData.PO.TNA_submitted=='' || this.resultData.PO.TNA_submitted==null || this.resultData.PO.TNA_submitted==undefined){
          this.TNA_submitted= 0;
          }
        else{
          this.TNA_submitted= this.resultData.PO.TNA_submitted;
        }

        if(this.resultData.Tna.tna_approved=='' || this.resultData.Tna.tna_approved==null || this.resultData.Tna.tna_approved==undefined){
          this.tna_approved= 0;
          }
        else{
          this.tna_approved= this.resultData.Tna.tna_approved;
        }

        if(this.resultData.PO.In_Preparation=='' || this.resultData.PO.In_Preparation==null || this.resultData.PO.In_Preparation==undefined){
                      this.In_Preparation= 0;
                      }
                    else{
                      this.In_Preparation= this.resultData.PO.In_Preparation;
                    }
                    if(this.resultData.PO.In_Production=='' || this.resultData.PO.In_Production==null || this.resultData.PO.In_Production==undefined){
                      this.In_Production= 0;
                      }
                    else{
                      this.In_Production= this.resultData.PO.In_Production;
                    }



                    if(this.resultData.PO.Ready_for_Dispatch=='' || this.resultData.PO.Ready_for_Dispatch==null || this.resultData.PO.Ready_for_Dispatch==undefined){
                      this.Ready_for_Dispatch= 0;
                      }
                    else{
                      this.Ready_for_Dispatch= this.resultData.PO.Ready_for_Dispatch;
                    }

        if(this.resultData.Orders.Order_pending=='' || this.resultData.Orders.Order_pending==null || this.resultData.Orders.Order_pending==undefined){
          this.Order_pending= 0;
          }
        else{
          this.Order_pending= this.resultData.Orders.Order_pending;
        }

        if(this.resultData.Orders.Order_submitted=='' || this.resultData.Orders.Order_submitted==null || this.resultData.Orders.Order_submitted==undefined){
          this.Order_submitted= 0;
          }
        else{
          this.Order_submitted= this.resultData.Orders.Order_submitted;
        }

        if(this.resultData.Orders.Order_received=='' || this.resultData.Orders.Order_received==null || this.resultData.Orders.Order_received==undefined){
          this.Order_received= 0;
          }
        else{
          this.Order_received= this.resultData.Orders.Order_received;
        }


    
     
                  }   
                  else{
                    this.$fire({
                        text: "No records found",
                        type: "warning",
                        timer: 30000,
                      });
                  }
        
        })        
    },

    searchData:function(brand_id){
      console.log("selected_segment_id", this.selected_segment_id)
      this.updateFilters();
      this.displayDashboardData(brand_id);
    },

   // Search function api's

        /****** Function to Get Brand & Segments ********/
    getBrandSegmentList:function(){
      // document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");
      if (userData) {
        var userInfo = JSON.parse(userData);
        this.user_id = userInfo[0].user_id;
        this.brand_assign = userInfo[0].brand_assign;
        if (userInfo[0].user_type == "Brand_Manager") {
          this.selected_brand_manager = userInfo[0].user_id;
        } else {
          this.selected_brand_manager = userInfo[0].brand_manager;
        }
        var obj = {
          user_id: this.user_id,
          selected_brand: this.brand_assign,
          brand_manager: this.selected_brand_manager,
        };

        axios
          .post(`${CONSTANTS.API_URL}/getBrandSegmentList`, obj)
          .then((response) => {
           
            this.result = response.data;
            if (this.result.returnmsg === "Successful") {
              // document.getElementById("overlay").style.display = "none";
              this.segmentarray_list = this.result.returnvalue[0]['segment_list'];
              let tempsegement_list =[]
              this.result.returnvalue[0]['segment_list'].map((item, index) => {
                  let tempobj ={}
                  tempobj.text = item.segment_title
                  tempobj.value = item.segment_title
                  tempsegement_list.push(tempobj)

                })
              this.segmentarray_list = tempsegement_list
              
              this.segmentList_arr = this.result.returnvalue;
              this.totalRows = this.segmentList_arr[0]["segment_list"].length;

              if (this.totalRows > 0) {
                this.segment_id = this.segmentList_arr[0]["segment_list"][0][
                  "segment_id"
                ];
                this.brand_id = this.segmentList_arr[0]["segment_list"][0][
                  "brand_id"
                ];
                //this.showCollection(this.brand_id, this.segment_id);
              }

            }
            else{
              this.segmentList_arr = [];
              this.totalRows = 0;
            }
          })
           .catch((e) => {
            this.errors.push(e);
          });

      }
    },

        // Collection list accorfing to segment selected
    showCollection(brand_id, segment_id) {
      this.selected_collection_id=null,
      this.sub_catid=null,
      this.selected_po_id=null,
      this.sub_cat_id_arr = [];
      this.po_typearr = [];

      // document.getElementById("overlay").style.display = "block";
      this.collection_brand_id = brand_id;
      this.collection_segment_id = segment_id;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      // var user_id = userInfo[0].user_id;

      const Obj = {
        brand_id: brand_id,
        segment_id: segment_id,
        user_id:  userInfo[0].user_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getSegmentCollectionList`, Obj)
        .then((response) => {
          // document.getElementById("overlay").style.display = "none";
          if (response.data.returnmsg == "Successful") {

            //  this.collectionData = response.data.returnvalue.collections;
            //  console.log("collections");
            // console.log(this.collectionData);
            let tempcollction_list =[]
                response.data.returnvalue.collections.map((item, index) => {
                  let tempobj ={}
                  tempobj.text = item.collection_title
                  tempobj.value = item.collection_title
                  tempcollction_list.push(tempobj)

                })
            this.collectionData = tempcollction_list;
          }else{
            this.collectionData = []
          }
        })
         .catch((e) => {
            this.errors.push(e);
          });
    
    },

        /******Function To Get Sub Category List********/

      // Sub Category list accorfing to segment selected
        showSubcategory(collection_id) {
         // this.updateFilters(); 
          this.sub_catid = null,
          this.selected_po_id = null,
            this.po_typearr = [];
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

          // document.getElementById("overlay").style.display = "block";

          const Obj = {
            collection_id,
            user_id:  userInfo[0].user_id,
          };
          axios
            .post(`${CONSTANTS.API_URL}/getSubcategoryForDashboardFilter`, Obj)
            .then((response) => {
              // document.getElementById("overlay").style.display = "none";
              if (response.data.returnmsg == "Successful") {
                // this.sub_cat_id_arr = response.data.returnvalue;

                let tempsubcat_list = []
                response.data.returnvalue.map((item, index) => {
                  let tempobj ={}
                  tempobj.text = item.sub_cattitle
                  tempobj.value = item.sub_catid
                  tempsubcat_list.push(tempobj)

                })
                this.sub_cat_id_arr = tempsubcat_list
                
              }else{
                this.sub_cat_id_arr = []
              }
            })
            .catch((e) => {
                this.errors.push(e);
              });
                
        },

        /******Function To Get PO Type List********/
    getPoTypeList: function(subcat_id) {
      this.selected_po_id=null;

      // document.getElementById("overlay").style.display = "block";

      // this.isBusy = true;
      const Obj = {
        subcat_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getPoTypeList`, Obj)
        .then((response) => {
          // document.getElementById("overlay").style.display = "none";
          this.result = response.data;

          if (this.result.returnmsg === "Successful") {
            // this.po_typearr = this.result.returnvalue;
            let temppo_list =[]
                response.data.returnvalue.map((item, index) => {
                  let tempobj ={}
                  tempobj.text = item.title
                  tempobj.value = item.po_id
                  temppo_list.push(tempobj)

                })
              this.po_typearr = temppo_list
          } else {
            this.po_typearr = [];
            // this.totalRows=0;
            // this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    updateFilters(){
        
        const filters = {
          "selected_segment_id" : this.selected_segment_id,
          "selected_collection_id" : this.selected_collection_id,
          "sub_catid": this.sub_catid,
          "selected_po_id": this.selected_po_id
        };
        localStorage.setItem('filters',JSON.stringify(filters));
        console.log(filters);
        console.log(this.selected_po_id);
      },

    refresh: function () {
      this.collectionData = [];
      this.sub_cat_id_arr = [];
      this.po_typearr = [];
      
      this.selected_segment_id = null,
        this.selected_collection_id = null,
        this.sub_catid = null,
        this.selected_po_id = null,
        localStorage.removeItem('filters');
        this.showCollection(this.brand_id)
        this.showSubcategory(this.selected_collection_id)
        this.getPoTypeList(this.sub_catid)
        this.displayDashboardData();
    },

  }
}

</script>

<style>
.bg-aqua{
      background-color: #00c0ef !important;
      color: #fff!important;
      width: 150px;
  height: 140px;
  margin-left: 20px;
}
.bg-green{
      background-color: #00a65a !important;
       color: #fff!important;
       width: 150px;
  height: 140px;
}
.bg-yellow{
      background-color: #f39c12 !important;
       color: #fff!important;
       width: 150px;
  height: 140px;
}
.bg-pink{
  background-color: #FF69B4 !important;
   color: #fff!important;
   width: 150px;
  height: 140px;
}
.bg-purpal{  
    background-color: #9370DB !important;
     color: #fff!important;
     width: 150px;
  height: 140px;
}
.bg-cyan{
      background-color: #008B8B !important;
       color: #fff!important;  
       width: 150px;
  height: 140px;
}
.bg-red{
      background-color: #dd4b39 !important;
       color: #fff!important;
       width: 150px;
  height: 140px;
}
.bg-def{
  background-color: #f09642 !important;
   color: #fff!important;
  width: 150px;
  height: 140px;
}
.boxto .card-body{
  padding: 0px!important;
}
.heading{
  padding: 12px 12px 5px 12px!important;
}
.countcolor
{
      color:white !important;

}
.pointer
{
  cursor: pointer!important;
}

</style>